module.exports = __webpack_public_path__ + "static/media/SudokuClassicTeaser.5d63633b.jpg";